export default __webpack_public_path__ + "static/media/LO06.0581a740.mp3";